"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
var tailwind_1 = require("../constants/tailwind");
var CLASSES = {
    BUTTON: 'js-accordion-button',
    TARGET: 'js-accordion-target',
    SUMMARY: 'summary',
};
/**
 * アコーディオン開閉アニメーションクラス
 */
var Accordion = /** @class */ (function () {
    function Accordion(container, animeOptions, closingAnime, openingAnime) {
        if (animeOptions === void 0) { animeOptions = { duration: 300, easing: 'ease-in-out' }; }
        if (closingAnime === void 0) { closingAnime = function (target) { return [{ height: target.offsetHeight + 'px' }, { height: '0px' }]; }; }
        if (openingAnime === void 0) { openingAnime = function (target) { return [{ height: '0px' }, { height: target.offsetHeight + 'px' }]; }; }
        var _a;
        this.container = container;
        this.animeOptions = animeOptions;
        this.closingAnime = closingAnime;
        this.openingAnime = openingAnime;
        // isAccordionInitiallyOpenを初期化（window.guideParams.isAccordionInitiallyOpenの値を取得）
        var guideParams = (_a = window.guideParams) !== null && _a !== void 0 ? _a : {};
        this.isAccordionInitiallyOpen =
            guideParams.isAccordionInitiallyOpen === true || guideParams.isAccordionInitiallyOpen === 'true';
        this.initEvent();
    }
    /**
     * Desktop判定用メソッド（768px以上）
     */
    Accordion.prototype.isDesktopView = function () {
        return window.matchMedia('(min-width: 768px)').matches;
    };
    /**
     * イベントの初期化
     */
    Accordion.prototype.initEvent = function () {
        var _this = this;
        var details = this.container.querySelectorAll('.details');
        if (details.length === 0)
            return;
        details.forEach(function (detail) {
            var forceClosed = detail.classList.contains('details--force-closed');
            detail.classList.add(tailwind_1.TAILWIND_CLASSES.OVERFLOW_HIDDEN);
            var summary = detail.querySelector(".".concat(CLASSES.SUMMARY));
            var target = detail.querySelector(".".concat(CLASSES.TARGET));
            var button = detail.querySelector(".".concat(CLASSES.BUTTON));
            if (!summary || !target || !button)
                return;
            // isAccordionInitiallyOpenとDesktop判定で初期表示を制御
            if (_this.isAccordionInitiallyOpen && _this.isDesktopView() && !forceClosed) {
                target.classList.remove('hidden');
                target.classList.add('md:block');
                button.classList.add(tailwind_1.TAILWIND_CLASSES.OPEN);
                detail.dataset.open = 'true';
            }
            else {
                target.classList.add('hidden');
                target.classList.remove('md:block');
                button.classList.remove(tailwind_1.TAILWIND_CLASSES.OPEN);
                detail.dataset.open = 'false';
            }
            summary.addEventListener('click', function (e) {
                if (e.composedPath().some(function (el) { return el instanceof HTMLAnchorElement; }))
                    return;
                e.preventDefault();
                _this.toggle(detail, target, button);
            });
            button.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                _this.toggle(detail, target, button);
            });
        });
    };
    Accordion.prototype.toggle = function (detail, target, button) {
        if (detail.dataset.open === 'true') {
            this.closeAccordion(detail, target, button);
        }
        else {
            this.openAccordion(detail, target, button);
        }
    };
    /**
     * 開く
     */
    Accordion.prototype.openAccordion = function (detail, target, button) {
        detail.dataset.open = 'true';
        button.classList.add(tailwind_1.TAILWIND_CLASSES.OPEN);
        // isAccordionInitiallyOpenとDesktop判定でmd:blockを付与（Desktopで目次を表示する場合のみ）
        target.classList.remove('hidden');
        if (this.isAccordionInitiallyOpen && this.isDesktopView()) {
            target.classList.add('md:block');
        }
        else {
            target.classList.remove('md:block');
        }
        target.animate(this.openingAnime(target), this.animeOptions);
    };
    /**
     * 閉じる
     */
    Accordion.prototype.closeAccordion = function (detail, target, button) {
        var _this = this;
        var closingAnime = target.animate(this.closingAnime(target), this.animeOptions);
        closingAnime.onfinish = function () {
            detail.dataset.open = 'false';
            button.classList.remove(tailwind_1.TAILWIND_CLASSES.OPEN);
            target.classList.add('hidden');
            // isAccordionInitiallyOpenとDesktop判定でmd:blockを削除（Desktopで目次を閉じる場合のみ）
            if (_this.isAccordionInitiallyOpen && _this.isDesktopView()) {
                target.classList.remove('md:block');
            }
        };
    };
    return Accordion;
}());
exports.Accordion = Accordion;
